/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Clear: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M19.1025 6.00488C19.6067 6.05621 20 6.48232 20 7C20 7.51768 19.6067 7.94379 19.1025 7.99512L19 8H18.9404L18.1982 20.0615C18.1657 20.5888 17.7285 20.9999 17.2002 21H6.7998C6.30458 20.9999 5.88932 20.6387 5.8125 20.1592L5.80176 20.0615L5.05957 8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6L19 6L19.1025 6.00488ZM7.74023 19H16.2598L16.9365 8L7.06348 8L7.74023 19ZM14 3C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5L10 5C9.44772 5 9 4.55228 9 4C9 3.44772 9.44772 3 10 3L14 3Z'
      fill='currentColor'
    />
  </React.Fragment>
)
